// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsContainerSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var WIDGETS = {
    ReportPartFieldPropsContainer: require('./Izenda.ReportPartFieldPropsContainer')
  };

  module.exports = function (editorComp, reportDesignerModel, fieldStore) {
    var SCHEMA_DEF = {
      title: '',
      schemaKey: 'REPORT_PART_FIELD_PROPERTIES',
      component: 'ReportPartFieldPropsContainer',
      props: {
        reportDesignerModel: 'reportDesignerModel',
        fieldStore: 'fieldStore'
      },      
      fields: {}
    };

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: WIDGETS,

      // data to binding to fields
      source: {},

      // properties for different fields
      mappingProps: {
        reportDesignerModel: reportDesignerModel,
        fieldStore: fieldStore
      },

      // defined-function which fields need to execute to get its data
      mappingSource: {},

      onChangeValue: function (schemaData, changedKey, changedKeyPath, changedOthersInfo) {
      }
    };
  };
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartFieldPropsContainerSchema.js